<template>
  <div>
    <inputs
      :title="title" :type="type"
      :show-fabric-rolls="true"
      :barcode="true"
      :show-fabric-selection-mode="true"
      :show-external-order-selector="true"
      fabric-selection-mode-label="Manual (Select if there is no underlying order or you want to select which fabric is cut manually)"
    />
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
export default {
  components: {
    Inputs,
  },
  data() {
    return {
      title: "Scan fabric for S&N",
      type: "soft_and_neat"
    };
  },
};
</script>
